export default __webpack_public_path__ + "static/media/web-icon.bb414fcf.svg";